import boxDispatchIcon from "@assets/images/Box.svg";
import { Card, Divider, Grid, IconButton, Typography } from "@material-ui/core";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import FormSpacer from "@saleor/components/FormSpacer";
import { useTemplateStyles } from "@saleor/dropOff/styles/templates";
import React from "react";
import SVG from "react-inlinesvg";

interface DropOffRackCardProps {
  rackName: string;
  numberOfBins: number;
  onDelete?: (rackId) => void;
  onCardClick?: () => void;
  rackId: string;
  isSelected: boolean;
  hideDeleteIcon?: boolean;
}

const DropOffRackCard: React.FC<DropOffRackCardProps> = props => {
  const {
    rackName,
    numberOfBins,
    onDelete,
    onCardClick,
    rackId,
    isSelected,
    hideDeleteIcon = false
  } = props;

  const classes = useTemplateStyles(props);

  return (
    <Card
      className={`${
        isSelected
          ? classes.dropOffHomeLocationCardDefault
          : classes.dropOffHomeLocationCard
      }`}
    >
      <Grid
        container
        className={classes.gridContainerRack}
        onClick={onCardClick}
      >
        <Grid item xs={10}>
          <Typography
            variant="h5"
            className={classes.dropOffCardAccordionMediumTitle}
          >
            {rackName}
          </Typography>
        </Grid>
        <Grid item xs={2} className={classes.circleContainer}>
          {hideDeleteIcon ? (
            <></>
          ) : (
            <IconButton
              className={classes.iconButtonDelete}
              onClick={() => onDelete(rackId)}
            >
              <DeleteOutlineOutlinedIcon />
            </IconButton>
          )}
        </Grid>
      </Grid>

      <FormSpacer spacing={1} />
      <Divider variant="fullWidth" />
      <FormSpacer spacing={1} />

      <Grid container className={classes.gridContainerBin}>
        <Grid item xs={6} className={classes.taskAreaCardBoxDispatchIcon}>
          <SVG src={boxDispatchIcon} />
          <span className={classes.binText}>{numberOfBins} BINS</span>
        </Grid>
      </Grid>
    </Card>
  );
};

export default DropOffRackCard;
